import { render } from "./TitleTypeComponent.vue?vue&type=template&id=2ae2d9fe&scoped=true"
import script from "./TitleTypeComponent.vue?vue&type=script&lang=js"
export * from "./TitleTypeComponent.vue?vue&type=script&lang=js"

import "./TitleTypeComponent.vue?vue&type=style&index=0&id=2ae2d9fe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ae2d9fe"]])

export default __exports__